// src/redux/order/order.selectors.js
import { createSelector } from 'reselect';

const selectOrder = state => state.order || { orders: [], loading: false, error: null, currentOrder: null };

export const selectOrders = createSelector(
  [selectOrder],
  order => order.orders || []
);

export const selectOrdersLoading = createSelector(
  [selectOrder],
  order => order.loading || false
);

export const selectCurrentOrder = createSelector(
  [selectOrder],
  order => order.currentOrder || null
);

export const selectOrdersError = createSelector(
  [selectOrder],
  order => order.error || null
);